export default "__VITE_ASSET__SHhLF51E__"